var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isNotice)?_c('div',{class:[`chat-message--${_vm.type}-notice`]},[_c('div',{staticClass:"title"},[_vm._v("公告:")]),_c('div',{class:[`chat-message--${_vm.type}-notice-text`]},[_vm._v(" "+_vm._s(_vm.notice)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }